import { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setPageValue, setFormValue } from "../../redux/slices/datasourcespageslice";
import { Toolbar, ToolbarItem, ToolbarSeparator, ToolbarSpacer,Button, DropDownButton } from "@progress/kendo-react-buttons";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Form } from "../../components/form";
import { Form as KendoForm, FormElement, Field } from "@progress/kendo-react-form";
import { Dialog,  DialogActionsBar } from "@progress/kendo-react-dialogs";
import { List } from "../../components/list";
import { getDataTypeIcon, getExpressionIcon, dataTypes, sortDirections} from "../../lib/utils";
import { ComputedFieldFunction } from "../../lib/computedfieldfunction";
import { AggregateFunction } from "../../lib/aggregatefunctions";
import { DropDownListById, FormDropDownListById, FormCheckbox, FormTextArea } from "../../forms/form-components";
import { disAllowedCharactersInTitle } from "../../settings";
import i18next from "i18next";
import { useTranslation } from "react-i18next";


const listItemRenderer = (pageState, currentTheme, formRenderProps, t) => (props, item, index) => {
    const {
        formRenderProps, onOpenComputedFieldDialog, onOpenExpressionFieldDialog, onDragStart, onDragOver, onDrop, onDragStartHelper, onDragOverHelper, onDropHelper, onFieldTitleChange, ...other
    } = props;

    const dataTypeIcon = getDataTypeIcon(item.DataTypeId);
    const expressionIcon = getExpressionIcon(item.FieldIsAggregate);
    const onFieldRemove = props.onFieldRemove;

    const handleOnDragStart = e => {
        let data = onDragStartHelper(e, item);
        if (onDragStart)
            onDragStart(e, data, formRenderProps);
    };

    const getGroupingByTypeId = (typeId) =>{
        return [
            { id: 0, title: "None" },
            { id: 1000, title: "GroupBy"},
            ...AggregateFunction.functions.filter(e => e.appliesToDataType(typeId)).map(e => ({id: e.id, title: e.title}))
        ];   
    };

    const handleOnDragOver = e =>{
        onDragOverHelper(e);

        if (onDragOver)
            onDragOver(e, formRenderProps);
    };

    const handleOnDrop = e => {
        let data = onDropHelper(e);
        if (onDrop)
            onDrop(e, data, formRenderProps);
    };
    
    //let tooltipText = item.IsComputedField ? "You can drag & drop to reorder, and double click to edit" : "You can drag & drop to reorder";
    let tooltipText = "";

    //console.log(item)
    if (item.HasComputedFunction)
    {
        let computedFunction = ComputedFieldFunction.getById(item.FunctionId);
        let parentField = pageState.formValues.Fields.find(e => e.Id == item.ParentFieldId);
        if(parentField)
        {
            let title = computedFunction.title +"(" + parentField.Title + ")";
            tooltipText = title;// + "\r\n" + tooltipText;
        }
    }
    else if (item.HasExpressionBody)
        tooltipText = t("datasources.expressionfield") + item.ExpressionBody;
    else
    {
        let obj = pageState.currentDataset.Fields.find(e => e.Id == item.FieldId);
        if (obj)
        {
            if (obj.IsExpression)
            {
                if (obj.IsAggregate)
                    tooltipText = `t("datasources.aggexp1") ${obj.ExpressionBody}`;
                else
                    tooltipText = `t("datasources.expression") ${obj.ExpressionBody}`;
            }
            else 
                tooltipText = `t("datasources.field1") ${obj.Title}`;
        }
    }


    // if (item.HasComputedFunction)
    // {
    //     let computedFunction = ComputedFieldFunction.getById(item.FunctionId);
    //     let parentField = pageState.formValues.Fields.find(e => e.Id == item.ParentFieldId);
    //     if(parentField)
    //     {
    //         let title = computedFunction.title +"(" + parentField.Title + ")";
    //         tooltipText = title + "\r\n" + tooltipText;
    //     }
    // }

    return (            
      <div key={item.Id} className={`list-item`} title={tooltipText}
           data-drag-id={item.Id} draggable="true" onDragStart={handleOnDragStart} onDragOver={handleOnDragOver} onDrop={handleOnDrop}>
        <div style={{fontWeight: 700}}>{index+1} -</div>
        <div className={`list-item-data-type-icon k-icon ${dataTypeIcon} `}></div>
        <div className={`list-item-expression-icon k-icon ${expressionIcon}`}></div>
        <div style={{width: "100%"}}>
            <Input maxLength={50} disabled={pageState.processing || pageState.formValues.IsSystem} value={item.Title} 
            onChange={e => props.onFieldTitleChange(e, item, formRenderProps)}
            onKeyPress = {e => {
                let v = e.key;
                if (disAllowedCharactersInTitle.indexOf(v) >= 0)
                {
                    e.preventDefault();
                    return;
                }
            }}
            />
        </div>  
        <div style={{width: 145}}>      
        {
            !item.FieldIsAggregate && !item.IsComputedField &&             
                <DropDownListById className="cmb-function" disabled={pageState.processing || pageState.formValues.IsSystem }// || (pageState.mode==2 && pageState.formValues.IsWidgetAttached)}  
                    data={getGroupingByTypeId(item.DataTypeId)} dataItemKey="id" textField="title"  
                    value={item.FunctionId} onChange={e => props.onFieldGroupingChange(e, item, formRenderProps)} />           
        }
        {
            item.IsComputedField && 
            <Button disabled={pageState.processing || pageState.formValues.IsSystem }
                className="buttons-container-button" style={{color: currentTheme.componentText, backgroundColor: currentTheme.componentBg, width: 175}} 
                onClick={e => {
                    if (item.IsComputedField)
                    {
                        if (item.HasComputedFunction)
                            onOpenComputedFieldDialog(2, item.Id, item.FunctionId, item.ParentFieldId);
                        else
                            onOpenExpressionFieldDialog(2, item.Id, item.DataTypeId, item.IsDecimal, item.IsPercent, item.ExpressionBody);
                    }}
                    }
            >
                { item.HasComputedFunction ? t("datasources.editfct") : t("datasources.editexp")}
            </Button>
        }
         </div>  
         <div style={{width: 80}}>      
        {
            !item.IsComputedField && 
            <DropDownListById className="cmb-sort-direction" disabled={pageState.processing || pageState.formValues.IsSystem }// || (pageState.mode==2 && pageState.formValues.IsWidgetAttached)}  
                    data={sortDirections} dataItemKey="Id" textField="Title"  
                    value={item.SortDirection} onChange={e => props.onFieldSortDirectionChange(e, item, formRenderProps)} />
        }
        </div>    
        <div className="list-item-delete">
            <Button disabled={pageState.processing || pageState.formValues.IsSystem} 
                  style={{border: "none", color: currentTheme.error, backgroundColor: "transparent"}} 
                icon="close" onClick={e => onFieldRemove(item, t, formRenderProps)}></Button>
        </div>        
    </div>             
    );
};

const dialogListItemRenderer = currentTheme => (props, item, index) => {
    const dataTypeIcon = getDataTypeIcon(item.DataTypeId);
    const expressionIcon = getExpressionIcon(item.FieldIsAggregate);
    const onFieldCheck = props.onFieldCheck;

    return (            
      <div key={item.FieldId} className={`list-item`}>
        <div style={{width:28}}><Checkbox value={item.Checked} onChange={e => onFieldCheck(item)} /></div>
        <div className={`list-item-data-type-icon k-icon ${dataTypeIcon} `}></div>
        <div className={`list-item-expression-icon k-icon ${expressionIcon}`}></div>
        <div className="list-item-title">{item.Title}</div>    
    </div>             
    );
};

const toolbarRenderer = props => {
    const {dispatch, pageState, fields, currentTheme, onSave, onClose, t,...other} = props;

    return (        
        <Fragment>
            <div className="datasourcespage-fields-dialog toolbar">
                <Toolbar>
                    <ToolbarItem>
                        <Button style={{color: currentTheme.primary}}   icon="save" onClick={onSave}>
                            {t("datasources.save1")}
                        </Button>
                    </ToolbarItem>
                    <ToolbarSeparator/>
                    <ToolbarItem>
                        <Input tabIndex={0} placeholder={t("datasources.locate")} style={{  width: 320}}
                            onChange={e =>
                                {
                                    let title = e.value.trim().toLowerCase();
                                    let fieldGroups = pageState.currentDataset.FieldGroups;
                                    // if (title && fieldGroups.find(e => e.Title.trim().toLowerCase() == title))
                                    //     dispatch(setPageValue({id: "fieldsToAdd", value: fields.map(item => {                                    
                                    //         if (item.FieldGroupTitle.trim().toLowerCase().indexOf(title) == 0)
                                    //             return ({...item, IsVisible: true});
                                    //         else
                                    //             return ({...item, IsVisible: false});
                                    //     })}));
                                    // else
                                    dispatch(setPageValue({id: "fieldsToAdd", value: fields.map(item => {                                    
                                        if (item.Title.toLowerCase().indexOf(title) >= 0)
                                            return ({...item, IsVisible: true});
                                        else
                                            return ({...item, IsVisible: false});
                                    })
                                }));
                            }} />
                    </ToolbarItem>
                    <ToolbarSeparator/>
                    <ToolbarItem>
                        <Button style={{color: currentTheme.primary}}   icon="close" onClick={onClose}>
                            {t("datasources.close")}
                        </Button>
                    </ToolbarItem>                    
                </Toolbar>
            </div>
            <style>
                {
                    `
                    /*form toolbar*/
                    .datasourcespage-fields-dialog.toolbar .k-toolbar
                    {
                      /*width: 100%;*/
                      border-left: none !important;
                      border-bottom: 1px solid ${currentTheme.separatorColor};
                      border-top: none !important;
                      border-right: none !important;
                      /*padding: 5px 4px 5px 0px !important;
                      background-color: ${currentTheme.dialogToolbarBg}!important;*/
                    }

                    .datasourcespage-fields-dialog.toolbar .k-button
                    {
                      /*the toolbar buttons*/
                      border: none;
                      padding: 6px 8px;
                    }

                    .datasourcespage-fields-dialog.toolbar .k-separator 
                    {
                        border-color: ${currentTheme.appBarLinkColor} !important;
                    }

                    .datasourcespage-fields-dialog.toolbar .k-toolbar .k-split-button:focus, .form-root .toolbar .k-toolbar .k-split-button.k-focus,
                    .datasourcespage-fields-dialog.toolbar .k-toolbar .k-button-solid-base:focus, .form-root .toolbar .k-toolbar .k-button-solid-base.k-focus
                    {
                        box-shadow: none !important;
                        border: none !important;
                    }

                    .datasourcespage-fields-dialog.toolbar .k-toolbar .k-button:active::before, .datasourcespage-fields-dialog.toolbar .k-toolbar .k-button:hover::before,
                    .datasourcespage-fields-dialog.toolbar .k-toolbar .k-button:focus::before, .datasourcespage-fields-dialog.toolbar .k-toolbar .k-button:focus-within::before                        
                    {
                        opacity: 0 !important;
                        border: none !important;
                        box-shadow: none !important;
                    }

                    .datasourcespage-fields-dialog.toolbar .k-toolbar .k-dropdown-button.k-focus .k-button::after
                    {
                        /*border: 1px solid ${currentTheme.componentBg} !important;*/
                        box-shadow: none !important;
                    }     

                    .datasourcespage-fields-dialog input
                    {
                        background-color: transparent;
                        color: ${currentTheme.dialogToolbarText};
                        border: none;
                    }

                    .datasourcespage-fields-dialog input:focus
                    {
                        background-color: transparent;
                        color: ${currentTheme.dialogToolbarText};
                        border: none;
                    }

                    .datasourcespage-fields-dialog input::placeholder
                    {
                        color: ${currentTheme.dialogToolbarText};
                    }
                    /*form toolbar*/
                    `
                }
            </style>        
        </Fragment>        
    );
};


const actionRenderer = currentTheme => (props) => {
    if (props.item.actionName == "")
       return <div className="separator" disabled={true} style={{width: "100%", height: 1, borderBottom: `1px solid ${currentTheme.componentBorderColor}`}}></div>;

    return (
      <div>
        <span className={`k-icon k-i-${props.item.icon}`} role="presentation" />
        <span style={{paddingLeft: 16}}>{props.item.text}</span>
      </div>
    );
};

export const TableValueList = props =>
{
    const currentTheme = useSelector(state => state.currentTheme);
    const pageState = useSelector(state => state.dataSourcesPage);
    const formRenderProps = props.formRenderProps;
    const { t } = useTranslation();

    const actions = [
        {
          actionName: "1",
          text: t("datasources.addfields"),
          icon: "plus",
        },
        {
            actionName: "",
            disabled: true
        },
        {
            actionName: "2",
            text: t("datasources.addcomputer"),
            icon: "sum",
        },
        {
            actionName: "",
            disabled: true
        },
        {
            actionName: "3",
            text: t("datasources.addexp"),
            icon: "formula-fx",
        },
        {
            actionName: "",
            disabled: true
        },
        {
            actionName: "4",
            text: t("datasources.toggle"),
            icon: "hyperlink-open-sm",
        },
        {
            actionName: "",
            disabled: true
        },
        {
          actionName: "5",
          text: t("datasources.clear"),
          icon: "close",
          //disabled: true,
        },
    ];

    return (
        <Fragment>
            {
                ((pageState.mode == 1 || pageState.mode == 2) && pageState.formValues.TypeId == 2) &&
                <div className="table-section">
                    <div style={{display: "flex", flexDirection: "row", justifyContent:"space-between", alignItems: "center", padding: "0px 8px 2px 8px", borderBottom: `1px solid ${currentTheme.componentBorderColor}`}}>
                        {/* <Button disabled={pageState.processing || pageState.formValues.IsSystem} className="buttons-container-button" icon="plus" style={{color: currentTheme.componentText, backgroundColor: currentTheme.componentBg}} onClick={props.onOpenFieldsDialog}>Fields</Button>
                        <Button disabled={pageState.processing || pageState.formValues.IsSystem} className="buttons-container-button" icon="plus" style={{color: currentTheme.componentText, backgroundColor: currentTheme.componentBg}} onClick={e => props.onOpenComputedFieldDialog(1)}>Computed Field</Button>
                        <Button disabled={pageState.processing || pageState.formValues.IsSystem} className="buttons-container-button" icon="plus" style={{color: currentTheme.componentText, backgroundColor: currentTheme.componentBg}} onClick={e => props.onOpenExpressionFieldDialog(1)}>Expression Field</Button>
                        <Button disabled={pageState.processing || pageState.formValues.IsSystem} className="buttons-container-button" icon="close" style={{color: currentTheme.componentText, backgroundColor: currentTheme.componentBg}} onClick={e => props.onFieldsClear(e, formRenderProps)}>Clear</Button> */}
                        <div style={{fontSize: 14}}>{t("datasources.fields")}</div>
                        <DropDownButton popupSettings={{popupClass:"table-datasources-actions"}} 
                            disabled={pageState.processing || pageState.formValues.IsSystem} buttonClass="table-datasources-actions-button"
                            style={{fontSize:18, fontWeight: 700}} fillMode={"flat"} itemRender={actionRenderer(currentTheme)} items={actions} textField="text" 
                            icon="more-horizontal" 
                            onItemClick={e => {
                                let id = e.item.actionName;

                                if (id == "1")
                                    props.onOpenFieldsDialog();
                                else if (id == "2")
                                    props.onOpenComputedFieldDialog(1);
                                else if (id == "3")
                                    props.onOpenExpressionFieldDialog(1);
                                else if (id == "4")
                                    props.onToggleViewMode();
                                else if (id == "5")
                                    props.onFieldsClear(e, formRenderProps);
                            }} 
                        />
                    </div>
                    <List className="table-fields" formRenderProps={formRenderProps}
                          items={pageState.formValues.Fields} itemRenderer={listItemRenderer(pageState, currentTheme, props.formRenderProps,t)} 
                          onOpenComputedFieldDialog={props.onOpenComputedFieldDialog} onOpenExpressionFieldDialog={props.onOpenExpressionFieldDialog}
                          onDragStart={props.onFieldDragStart} onDragOver={props.onFieldDragOver} onDrop={props.onFieldDrop} 
                          onFieldTitleChange={props.onFieldTitleChange}
                          onFieldGroupingChange={props.onFieldGroupingChange} onFieldSortDirectionChange={props.onFieldSortDirectionChange}
                          onFieldRemove={props.onFieldRemove}
                    />
                    {/* { 
                      !pageState.processing && !pageState.formValues.IsSystem && pageState.formValues.Fields.length > 0 &&
                      <div style={{color: currentTheme.touchColor, fontSize: 13, fontStyle: "italic", marginTop:4, marginLeft: 12}}>N.B. You can drag and drop to re-order the fields</div>
                    } */}
                </div>
            }
            <FieldsDialog formRenderProps={formRenderProps} onClose={props.onCloseFieldsDialog} onSaveFieldsDialog={props.onSaveFieldsDialog} onFieldCheck={props.onFieldCheck} />
            <ComputedFieldDialog parentFormRendererProps={formRenderProps} onValidate={props.onValidateComputedFieldDialog} onSave={props.onSaveComputedFieldDialog} onClose={props.onCloseComputedFieldDialog} />
            <ExpressionFieldDialog parentFormRendererProps={formRenderProps}  onValidate={props.onValidateExpressionFieldDialog} onSave={props.onSaveExpressionFieldDialog} onClose={props.onCloseExpressionFieldDialog} />

            <style>
                {
                    `
                        .datasources-page-form .k-form .table-section
                        {
                            width: 100%;
                            margin-top: ${pageState.formValues.ViewMode == 1 ? "38px" : "4px"};
                            border: 1px solid ${currentTheme.componentBorderColor};
                            border-radius: 6px;
                            padding: 2px 4px 12px 4px;
                        }

                        .datasources-page-form .k-form .table-fields
                        {
                            margin-top:12px;
                        }

                        .datasources-page-form .k-form .table-fields
                        {
                            padding:4px;
                            /*border: 1px solid ${currentTheme.componentBorderColor};*/
                            width: 100%;
                        }

                        .datasources-page-form .k-form .table-fields .list-item
                        {
                            white-space:nowrap;
                            
                        }

                        .datasources-page-form .k-form .table-fields .list-item:hover
                        {
                            cursor: grab;
                            background-color: ${currentTheme.componentBgFaded};
                        }

                        .datasources-page-form .k-form .table-fields .list-item-title
                        {
                            vertical-align: middle;
                            font-size:0.85rem;
                            width: 280px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        .datasources-page-form .k-form .table-fields .list-item-delete
                        {
                            width: 40px;
                        }

                        .datasources-page-form .k-form .table-fields .list-item .cmb-function
                        {
                            
                        }

                        .datasources-page-form .k-form .table-fields .list-item .k-input
                        {                           
                            width: 100%;/*a little bit smaller than the title*/
                        }

                        .datasources-page-form .table-datasources-actions-button:focus::after
                        {
                            border: none !important;
                            outline: none !important;
                            box-shadow: none !important;
                        }

                        .table-datasources-actions .k-menu-item:nth-child(2):hover,
                        .table-datasources-actions .k-menu-item:nth-child(4):hover,
                        .table-datasources-actions .k-menu-item:nth-child(6):hover,
                        .table-datasources-actions .k-menu-item:nth-child(8):hover
                        {
                            background-color: tranpsarent !important;
                            background: none !important;
                        }

                        .table-datasources-actions .k-menu-item:nth-child(2),
                        .table-datasources-actions .k-menu-item:nth-child(4),
                        .table-datasources-actions .k-menu-item:nth-child(6),
                        .table-datasources-actions .k-menu-item:nth-child(8)
                        {
                            padding: 0;
                        }
                        .table-datasources-actions .k-menu-item:nth-child(1),
                        .table-datasources-actions .k-menu-item:nth-child(3),
                        .table-datasources-actions .k-menu-item:nth-child(5),
                        .table-datasources-actions .k-menu-item:nth-child(7),
                        .table-datasources-actions .k-menu-item:nth-child(9)
                        {
                            padding-top: 7px;
                            padding-bottom: 7px;
                        }
                    `
                }
            </style>
        </Fragment>
    );
};


export const FieldsDialog = props => 
{
    const dispatch = useDispatch();
    const currentTheme = useSelector(state => state.currentTheme);
    const pageState = useSelector(state => state.dataSourcesPage);
    const appearance = useSelector(state => state.appearance); 
    const { onSave, onClose, ...other} = props;
    const {t} = useTranslation();

    let fieldsToAdd = [...pageState.fieldsToAdd];

    return (
        <Fragment>
            {
                pageState.fieldsDialogOpen &&
                <Dialog className="datasources-fields-dialog" title={null}>
                    <Form className="form" dispatch={dispatch} pageState={pageState} fields={pageState.fieldsToAdd} currentTheme={currentTheme} 
                            toolbarRenderer={toolbarRenderer} t={t} onSave={e => props.onSaveFieldsDialog(props.formRenderProps)} onClose={onClose}                      
                            errorMessages={[]} onErrorbarClose={()=>{}}
                    >
                        <List className="list" items={fieldsToAdd.filter(e => e.IsVisible)} itemRenderer={dialogListItemRenderer(currentTheme)} onFieldCheck={props.onFieldCheck} />
                    </Form>
                </Dialog>
            }
            <style>
                {
                    `
                    .datasources-fields-dialog
                    {
                        width:500px;
                        height: 500px;
                        left: calc(50% - 250px);
                        top: calc(50% - 250px);
                        direction:${appearance.isRightToLeft ? "rtl" : "ltr"} ;
                    }

                    .datasources-fields-dialog .k-dialog-content
                    {
                        padding: 0 !important;
                    }

                    .datasources-fields-dialog .k-dialog
                    {
                        min-width: 500px;
                        width: 500px;
                        height: 400px;
                    }

                    .datasources-fields-dialog .form
                    {
                        width: 100%;
                    }

                    .datasources-fields-dialog .list-container
                    {
                        border: none;
                        padding: 8px;
                        margin-top: 0px;
                    }
                    `
                }
            </style>
        </Fragment>
    );
};


export const ComputedFieldDialog = props => 
{
    const dispatch = useDispatch();
    const currentTheme = useSelector(state => state.currentTheme);
    const pageState = useSelector(state => state.dataSourcesPage);
    const { parentFormRendererProps, onValidate, onSave, onClose, ...other} = props;
    const appearance = useSelector(state => state.appearance);  
    const { t } = useTranslation();

    let mode = pageState.computedFieldMode;
    let computedFieldId = pageState.computedFieldFieldId;
    let computedFunctionId = pageState.computedFieldFunctionId;
    let computedParentFieldId = pageState.computedFieldParentFieldId;

    let computedFunctions = [{id: 0, title: t("datasources.none"), name: "None"}, ...ComputedFieldFunction.functions.sort((a, b) => (a.title < b.title ? -1 : (a.title == b.title ? 0 : 1)))];
    let computedFunction = computedFunctionId <= 0 ? null : ComputedFieldFunction.getById(computedFunctionId);

    let fields = [{Id: null, Title: t("datasources.none"), Name: "None"}];

    if(computedFunction != null)       
        fields = [...fields, ...pageState.formValues.Fields.filter(e => e.Id != computedFieldId && computedFunction.appliesToDataType(e.DataTypeId))];       

    //do an extra test to make sure comptedParentFieldId is in fields - normally it shall be unless we change its type to one that function id cannot apply to it
    if (computedParentFieldId != null)
    {
        if (!fields.find(e => e.Id == computedParentFieldId))
        {
            computedParentFieldId = null;
            dispatch(setPageValue({id: "computedFieldParentFieldId", value: null}));
        }
    }

    return (
        <Fragment>
            {
                pageState.computedFieldDialogOpen &&
                <Dialog className="datasources-computed-field-dialog" title={null}>
                    <KendoForm    
                        validator={onValidate} 
                        key={"ComputedFieldDialogForm"}
                        initialValues={{ComputedFunctionId: computedFunctionId, ComputedParentFieldId: computedParentFieldId}}
                        render={(formRenderProps) => {
                            return (
                                <FormElement horizontal={false}
                                        style={{
                                            // width: 250,
                                        }}
                                >                       
                                    <div className="toolbar">
                                        <Toolbar>
                                            <ToolbarItem>
                                                <Button style={{color: currentTheme.primary}}   icon="save" onClick={e => onSave(parentFormRendererProps)}>
                                                   {t("datasources.save")}
                                                </Button>
                                            </ToolbarItem>
                                            <ToolbarSeparator/>
                                            <ToolbarItem>
                                                <Button  style={{color: currentTheme.primary}}   icon="cancel" onClick={e => onClose()}>
                                                    {t("datasources.cancel")}
                                                </Button>
                                            </ToolbarItem>
                                        </Toolbar>            
                                    </div>
                                    <div className="form-content">  
                                        <div>
                                            <Field
                                                id={"ComputedFunctionId"}
                                                name={"ComputedFunctionId"}
                                                label={t("datasources.function1")}
                                                component={FormDropDownListById}
                                                data={computedFunctions} dataItemKey="id" textField="title"   
                                                onChange={ e =>
                                                    {
                                                        dispatch(setPageValue({id: "computedFieldFunctionId", value: e.value}));
                                                        dispatch(setPageValue({id: "computedFieldParentFieldId", value: null}));

                                                        formRenderProps.onChange("ComputedParentFieldId", { value: null});

                                                    }   
                                                }                                          
                                                style={{width: "100%", marginTop:4}}
                                            />     
                                        </div>
                                        <div style={{marginTop: 26}}>
                                            <Field
                                                id={"ComputedParentFieldId"}
                                                name={"ComputedParentFieldId"}
                                                label={t("datasources.field4")}
                                                component={FormDropDownListById}
                                                data={fields} dataItemKey="Id" textField="Title"  
                                                onChange={ e =>
                                                    {
                                                        dispatch(setPageValue({id: "computedFieldParentFieldId", value:e.value}));
                                                    }}
                                                style={{width: "100%", marginTop:4}}
                                            />     
                                        </div>
                                    </div>
                                </FormElement>
                            );
                        }}
                    />
                </Dialog>
            }
            <style>
                {
                    `
                    .datasources-computed-field-dialog
                    {
                        width:500px;
                        height: 500px;
                        left: calc(50% - 250px);
                        top: calc(50% - 250px);
                        direction:${appearance.isRightToLeft ? "rtl" : "ltr"} 
                    }

                    .datasources-computed-field-dialog .k-dialog-content
                    {
                        padding: 0 !important;
                    }

                    .datasources-computed-field-dialog .k-dialog
                    {
                        min-width: 500px;
                        width: 500px;
                    }

                    .datasources-computed-field-dialog .k-form
                    {
                        width: 100%;
                        height: 100%;
                    }

                    .datasources-computed-field-dialog .k-form .form-content
                    {
                        padding: 12px 26px 28px 26px;
                    }

                    .datasources-computed-field-dialog .toolbar .k-button
                    {
                        border: none;
                        background-color:transparent;
                    }
                    
                    .datasources-computed-field-dialog .toolbar 
                    {
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                    }

                    .datasources-computed-field-dialog .toolbar .k-separator 
                    {
                        border-color: ${currentTheme.appBarLinkColor} !important;
                    }

                    `
                }
            </style>
        </Fragment>
    );
};


export const ExpressionFieldDialog = props => 
{
    const dispatch = useDispatch();
    const currentTheme = useSelector(state => state.currentTheme);
    const pageState = useSelector(state => state.dataSourcesPage);
    const {parentFormRendererProps, onValidate, onSave, onClose, ...other} = props;
    const appearance = useSelector(state => state.appearance);  
    const {t} = useTranslation();

    let incrementedDataTypes = [{Id:0, Title: "None"}, ...dataTypes];

    let mode = pageState.computedFieldMode;
    let fieldId = pageState.expressionFieldFieldId;
    let dataTypeId = pageState.expressionFieldDataTypeId;
    let isDecimal = dataTypeId == 2 ? pageState.expressionFieldIsDecimal : false;
    let isPercent = dataTypeId == 2 ? pageState.expressionFieldIsPercent : false;
    let body = pageState.expressionFieldBody;

    return (
        <Fragment>
            {
                pageState.expressionFieldDialogOpen &&
                <Dialog className="datasources-expression-field-dialog" title={null}>
                    <KendoForm    
                        validator={onValidate} 
                        key={"ExpressionFieldDialogForm"}
                        initialValues={{DataTypeId: dataTypeId, IsDecimal: isDecimal, IsPercent: isPercent, Body: body}}
                        render={(formRenderProps) => {
                            return (
                                <FormElement horizontal={false}
                                        style={{
                                            // width: 250,
                                        }}
                                >                       
                                    <div className="toolbar">
                                        <Toolbar>
                                            <ToolbarItem>
                                                <Button style={{color: currentTheme.primary}}   icon="save" onClick={e => onSave(parentFormRendererProps)}>
                                                   {t("datasources.save")}
                                                </Button>
                                            </ToolbarItem>
                                            <ToolbarSeparator/>
                                            <ToolbarItem>
                                                <Button  style={{color: currentTheme.primary}}   icon="cancel" onClick={e => onClose()}>
                                                   {t("datasources.cancel")}
                                                </Button>
                                            </ToolbarItem>
                                        </Toolbar>            
                                    </div>
                                    <div className="form-content">  
                                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
                                            <Field
                                                id={"DataTypeId"}
                                                name={"DataTypeId"}
                                                label={t("datasources.datatype1")}
                                                component={FormDropDownListById}
                                                data={incrementedDataTypes} dataItemKey="Id" textField="Title"   
                                                onChange={ e =>
                                                    {
                                                        dispatch(setPageValue({id: "expressionFieldDataTypeId", value: e.value}));
                                                        dispatch(setPageValue({id: "expressionFieldIsDecimal", value: false}));
                                                        dispatch(setPageValue({id: "expressionFieldIsPercent", value: false}));

                                                        formRenderProps.onChange("IsDecimal", { value: false});
                                                        formRenderProps.onChange("IsPercent", { value: false});
                                                    }   
                                                }                                          
                                                style={{width: "200px", marginTop:4}}
                                            />

                                            <div className="k-icon k-i-help microsoft-expressions" style={{color: currentTheme.primary}} onClick={e => {window.open("https://learn.microsoft.com/en-us/dotnet/api/system.data.datacolumn.expression?view=net-7.0", "_blank")}}></div>     

                                            <Field 
                                                id={"IsDecimal"} 
                                                name="IsDecimal" 
                                                label={t("datasources.decimal")} 
                                                component={FormCheckbox}
                                                onChange={ e => dispatch(setPageValue({id: "expressionFieldIsDecimal", value: e.value}))}
                                                disabled={dataTypeId != 2}
                                            />
                                            <Field 
                                                id={"IsPercent"} 
                                                name="IsPercent" 
                                                label={t("datasources.percentage")}
                                                component={FormCheckbox}
                                                onChange={ e => dispatch(setPageValue({id: "expressionFieldIsPercent", value: e.value}))}
                                                disabled={dataTypeId != 2}
                                            />
                                        </div>
                                        <div style={{marginTop: 26}}>
                                            <Field                                    
                                                id={"Body"}
                                                name={"Body"}
                                                label={t("datasources.expression4")}
                                                component={FormTextArea}
                                                style={{height:150, marginTop:4, fontFamily: "'courier new', monospace", fontSize:15, fontWeight: 400}}
                                                onChange={ e => dispatch(setPageValue({id: "expressionFieldBody", value:e.value}))}
                                                maxLength={1000} 
                                            />
                                        </div>
                                    </div>
                                </FormElement>
                            );
                        }}
                    />
                </Dialog>
            }
            <style>
                {
                    `                    
                    .datasources-expression-field-dialog
                    {
                        width:650px;
                        height: 500px;
                        left: calc(50% - 325px);
                        top: calc(50% - 250px);
                        direction:${appearance.isRightToLeft ? "rtl" : "ltr"} 
                    }

                    .datasources-expression-field-dialog .k-dialog-content
                    {
                        padding: 0 !important;
                    }

                    .datasources-expression-field-dialog .k-dialog
                    {
                        min-width: 650px;
                        width: 650px;
                    }

                    .datasources-expression-field-dialog .k-form
                    {
                        width: 100%;
                        height: 100%;
                    }

                    .datasources-expression-field-dialog .k-form .form-content
                    {
                        padding: 12px 26px 28px 26px;
                    }

                    .datasources-expression-field-dialog .toolbar .k-button
                    {
                        border: none;
                        background-color:transparent;
                    }
                    
                    .datasources-expression-field-dialog .toolbar 
                    {
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                    }

                    .datasources-expression-field-dialog .toolbar .k-separator 
                    {
                        border-color: ${currentTheme.appBarLinkColor} !important;
                    }

                    .datasources-expression-field-dialog .microsoft-expressions:hover
                    {
                        cursor: pointer;
                    }

                    `
                }
            </style>
        </Fragment>
    );
};